import React, { createContext, useState } from "react";

export const TokenContext = createContext();

export const TokenProvider = ({ children }) => {
  const [bearerToken, setBearerToken] = useState(null);
  const [_csrf, setCsrf] = useState(null);

  return (
    <TokenContext.Provider value={{ bearerToken, setBearerToken, _csrf, setCsrf }}>
      {children}
    </TokenContext.Provider>
  );
};
